// Hooks
import { useMenu } from '@/utils/hooks/menu/useMenu';

// Components
import { MenuEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntries';

// Types
import type { MenuEntriesProps } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntries';

type TopEntriesProps = OptionalFor<Omit<MenuEntriesProps, 'menuConfig'>, 'isMenuOpen'>;

export function TopEntries({
    openDropdown,
    stickyMenu,
    setOpenDropdown,
    isMenuOpen = true
}: TopEntriesProps) {
    const { mainMenu } = useMenu();
    return (
        <MenuEntries
            menuConfig={mainMenu}
            stickyMenu={stickyMenu}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            isMenuOpen={isMenuOpen}
        />
    );
}
